import { useEffect } from 'react';
import { X } from 'lucide-react';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  width?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

const widthCls = {
  sm: 'w-[360px]',
  md: 'w-[480px]',
  lg: 'w-[640px]',
};

export function SideDrawer({ open, title, onClose, width = 'md', children }: Props) {
  useEffect(() => {
    function escClose(e: KeyboardEvent) {
      if (e.key === 'Escape' && open) onClose();
    }
    document.addEventListener('keydown', escClose);
    return () => document.removeEventListener('keydown', escClose);
  }, [open, onClose]);

  return (
    <>
      <div
        onClick={onClose}
        className={`fixed inset-0 z-30 bg-bmade-950/40 backdrop-blur-sm transition-opacity ${
          open ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
      />
      <aside
        className={`fixed right-0 top-0 z-40 flex h-screen ${widthCls[width]} max-w-[90vw] flex-col border-l border-bmade-200 bg-white shadow-2xl transition-transform duration-200 dark:border-bmade-800 dark:bg-bmade-900 ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <header className="flex shrink-0 items-center justify-between border-b border-bmade-200 px-4 py-3 dark:border-bmade-800">
          <h2 className="text-sm font-semibold uppercase tracking-wider text-bmade-700 dark:text-bmade-300">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1 text-bmade-500 hover:bg-bmade-100 hover:text-bmade-900 dark:hover:bg-bmade-800 dark:hover:text-white"
            aria-label="Sluiten"
          >
            <X className="h-4 w-4" />
          </button>
        </header>
        <div className="flex-1 overflow-auto p-4">{children}</div>
      </aside>
    </>
  );
}
